import React, { Component, Fragment } from "react";
import UserRowCollapsable from './UserRowCollapsable.js';
import InputOnClick from '../InputOnClick.js';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import onClickOutside from "react-onclickoutside";

let InputOnClickWithOnClickOutside = onClickOutside(InputOnClick);

class UsersListItem extends Component
{
	constructor (props) {
		super(props);

		this.state = {
			disabled: this.props.user.isDeleted(),
			invited: ! this.props.user.isFullyRegistered()
		}

		this.permissionsTable = React.createRef();
		this.foldRow = this.foldRow.bind(this);
	}

	setDisabled = (bool) => {
		this.setState({ disabled: bool });
	}

	foldRow = () => {
		this.props.foldAction(this.props.user.props.id);
	}

	render () {
		const that = this;

		let rowClasses = ['user-rows'];

		if (!this.props.folded) {
			rowClasses.push('is-active');
		}

		if (this.state.disabled) {
			rowClasses.push('is-disabled');
		} else if (this.state.invited) {
			rowClasses.push('is-invited');
		}

		return (
			<div className={rowClasses.join(" ")}>
				<div className="user-row" onClick={this.foldRow}>
					<div className="user-row-chevrons">
					  <FontAwesomeIcon
					  	icon={this.props.folded ? 'angle-double-up' : 'angle-double-down'}
					  	color={
					  		this.props.folded || this.state.disabled
					  			? 'black'
					  			: 'white'
					  	}
					  />
					</div>
					<div className="user-row-details">
						<div className="level">
							<div className="level-left">
								{ this.props.user.getFirstname() && this.props.user.getLastname() &&
									<div className="level-item firstname-lastname">
										{this.props.user.getFirstname()} {this.props.user.getLastname()}
									</div>
								}
								{ !this.props.user.getFirstname() && !this.props.user.getLastname() &&
									<div className="level-item firstname-lastname">
										{this.props.user.getEmail()}
									</div>
								}
							</div>
							<div className="level-right">
								<div className="level-item email">
									{this.props.user.getEmail()}
								</div>
							</div>
						</div>
					</div>
				</div>
				<UserRowCollapsable
					foldRow={this.foldRow}
					folded={this.props.folded}
					serverTokens={this.props.serverTokens}
					user={this.props.user}
					disabledBeacon={this.setDisabled}
					deleter={this.props.deleter}
					updater={this.props.updater}
					enabler={this.props.enabler}
				/>
			</div>
		);
	}
}

export default UsersListItem;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersListItem.js